/* 子组件 2：ResultSection / Keyboard / HistoryDrawer / SettingsDrawer */

const _Tile2 = window.Tile;

// ====================== ResultSection ======================
const YAKU_NAME = {
  'riichi': '立直', 'double-riichi': '双立直', 'ippatsu': '一发', 'tsumo': '门清自摸',
  'tanyao': '断幺九', 'pinfu': '平和', 'iipeko': '一杯口', 'ryampeko': '二杯口',
  'field-wind': '场风牌', 'seat-wind': '自风牌',
  'white': '白', 'green': '發', 'red': '中',
  'rinshan': '岭上开花', 'chankan': '抢杠', 'haitei': '海底/河底',
  'sanshoku-dojun': '三色同顺', 'sanshoku-doko': '三色同刻', 'ittsu': '一气通贯',
  'chanta': '混全带幺九', 'junchan': '纯全带幺九',
  'chitoitsu': '七对子', 'toitoi': '对对和', 'sananko': '三暗刻', 'sankantsu': '三杠子',
  'shosangen': '小三元', 'honroto': '混老头',
  'honitsu': '混一色', 'chinitsu': '清一色',
  'dora': '宝牌', 'ura-dora': '里宝牌', 'red-dora': '赤宝牌',
  'kokushi': '国士无双', 'kokushi-13': '国士无双十三面',
  'suanko': '四暗刻', 'suanko-tanki': '四暗刻单骑',
  'daisangen': '大三元', 'tsuiso': '字一色', 'shosushi': '小四喜', 'daisushi': '大四喜',
  'ryuiso': '绿一色', 'chinroto': '清老头', 'sukantsu': '四杠子',
  'churen': '九莲宝灯', 'pure-churen': '纯正九莲宝灯',
  'tenho': '天和', 'chiho': '地和'
};

const FU_NAME = {
  'futei': '底符', 'tsumo': '自摸', 'menzen-ron': '门清荣和', 'kui-pinfu': '副露平和形',
  'dragon-head': '三元雀头', 'round-wind-head': '场风雀头', 'seat-wind-head': '自风雀头', 'double-wind-head': '连风雀头',
  'tanki': '单骑', 'kanchan': '嵌张', 'penchan': '边张',
  'chunchan-anko': '中张暗刻', 'chunchan-minko': '中张明刻',
  'chunchan-ankan': '中张暗杠', 'chunchan-minkan': '中张明杠',
  'yaochu-anko': '幺九暗刻', 'yaochu-minko': '幺九明刻',
  'yaochu-ankan': '幺九暗杠', 'yaochu-minkan': '幺九明杠',
};

function ResultSection({ th, s, result, seatWind, by, showFuDetail, onSave }) {
  const [saved, setSaved] = React.useState(false);
  const handleSave = () => {
    onSave();
    setSaved(true);
    setTimeout(() => setSaved(false), 1500);
  };
  if (!result) {
    return (
      <div style={{ margin: '12px', padding: '20px 14px', background: th.panel, border: `1px dashed ${th.line}`, borderRadius: 6, textAlign: 'center' }}>
        <div style={{ fontSize: 11, color: th.ink2, letterSpacing: '0.3em' }}>请输入手牌（含和牌）</div>
      </div>
    );
  }
  if (result.error) {
    return (
      <div style={{ margin: '12px', padding: '14px', background: th.panel, border: `1px solid ${th.line}`, borderRadius: 6, textAlign: 'center' }}>
        <div style={{ fontSize: 12, color: th.accent, fontFamily: '"PingFang SC","Hiragino Mincho ProN","Songti SC",ui-serif,serif', letterSpacing: '0.2em' }}>无役 / 牌型不成立</div>
        <div style={{ fontSize: 10, color: th.ink2, marginTop: 4 }}>请检查是否缺役、形不和</div>
      </div>
    );
  }

  const isDealer = seatWind === '1z';
  const allYaku = [...result.yakuman.map(y => ({ name: y.name, han: y.times + '倍', yakuman: true })), ...result.yaku];
  const handCount = result.kind === 'yakuman' ? '' : `${result.fu} 符 ${result.han} 番`;

  return (
    <div style={{ margin: '12px' }}>
      {/* 主结果卡 */}
      <div style={{
        background: `linear-gradient(180deg, ${th.surface} 0%, ${th.panel} 100%)`,
        border: `1px solid ${th.line}`,
        borderRadius: 6,
        padding: '14px 14px 12px',
        position: 'relative',
        overflow: 'hidden'
      }}>
        {/* 装饰角标 */}
        {result.name && (
          <div style={{
            position: 'absolute', top: -1, right: -1,
            background: th.accent, color: '#fff',
            padding: '4px 12px 5px', fontSize: 11,
            fontFamily: '"PingFang SC","Hiragino Mincho ProN","Songti SC",ui-serif,serif', letterSpacing: '0.2em',
            borderBottomLeftRadius: 6
          }}>{result.name}</div>
        )}

        {/* 番符 */}
        <div style={{ fontSize: 11, color: th.ink2, letterSpacing: '0.2em', marginBottom: 4 }}>
          {handCount} · {by === 'tsumo' ? '自摸' : '荣和'} · {isDealer ? '亲家' : '子家'}
        </div>

        {/* 大点数 */}
        <div style={{ display: 'flex', alignItems: 'baseline', gap: 6, marginBottom: 8 }}>
          <span style={{ fontSize: 36, fontWeight: 600, color: th.ink, fontFamily: '"PingFang SC","Hiragino Mincho ProN","Songti SC",ui-serif,serif', lineHeight: 1 }}>
            {result.total.toLocaleString()}
          </span>
          <span style={{ fontSize: 12, color: th.ink2, fontFamily: '"PingFang SC","Hiragino Mincho ProN","Songti SC",ui-serif,serif' }}>点</span>
          {(result.honba > 0 || result.deposit > 0) && (
            <span style={{ fontSize: 10, color: th.ink2, marginLeft: 'auto' }}>
              {result.honba > 0 && `+本场 ${result.honba * 300}`}
              {result.deposit > 0 && ` +立直 ${result.deposit * 1000}`}
            </span>
          )}
        </div>

        {/* 谁付谁 */}
        <PaymentDisplay th={th} result={result} isDealer={isDealer} by={by} />
      </div>

      {/* 役一览 */}
      {allYaku.length > 0 && (
        <div style={{
          marginTop: 8, padding: '10px 12px',
          background: th.panel, border: `1px solid ${th.line}`, borderRadius: 6
        }}>
          <div style={{ fontSize: 10, color: th.ink2, letterSpacing: '0.2em', marginBottom: 6 }}>役 一 览</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            {allYaku.map((y, i) => (
              <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', borderBottom: i < allYaku.length-1 ? `1px dotted ${th.line}` : 'none', paddingBottom: 3 }}>
                <span style={{ fontSize: 13, color: y.yakuman ? th.accent : th.ink, fontFamily: '"PingFang SC","Hiragino Mincho ProN","Songti SC",ui-serif,serif', letterSpacing: '0.05em' }}>
                  {y.yakuman && <span style={{ fontSize: 9, color: th.accent, marginRight: 4 }}>役満</span>}
                  {YAKU_NAME[y.name] || y.name}
                </span>
                <span style={{ fontSize: 12, color: th.ink2, fontFamily: '"PingFang SC","Hiragino Mincho ProN","Songti SC",ui-serif,serif' }}>{y.han} 番</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* 符内详 */}
      {showFuDetail && result.fuDetail && result.kind === 'normal' && (
        <details style={{
          marginTop: 8, padding: '8px 12px',
          background: th.panel, border: `1px solid ${th.line}`, borderRadius: 6
        }}>
          <summary style={{ fontSize: 10, color: th.ink2, letterSpacing: '0.2em', cursor: 'pointer' }}>符 内 详 ▾</summary>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 2, marginTop: 6 }}>
            {result.fuDetail.map((f, i) => (
              <div key={i} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, color: th.ink2 }}>
                <span>{FU_NAME[f.name] || f.name}</span>
                <span style={{ fontFamily: '"PingFang SC","Hiragino Mincho ProN","Songti SC",ui-serif,serif' }}>+{f.fu}</span>
              </div>
            ))}
          </div>
        </details>
      )}

      {/* 保存 */}
      <button onClick={handleSave}
        style={{
          marginTop: 10, width: '100%', padding: '8px 0', fontSize: 12,
          background: saved ? th.accent : 'transparent',
          border: `1px solid ${saved ? th.accent : th.line}`,
          color: saved ? '#fff' : th.ink2,
          borderRadius: 4, cursor: 'pointer', letterSpacing: '0.3em', fontFamily: '"PingFang SC","Hiragino Mincho ProN","Songti SC",ui-serif,serif',
          transition: 'background 200ms, border-color 200ms, color 200ms',
        }}>{saved ? '已 记 入 ✓' : '记 入 历 史'}</button>
    </div>
  );
}

function PaymentDisplay({ th, result, isDealer, by }) {
  const honbaBonus = result.honba * 300;
  const depositBonus = result.deposit * 1000;
  if (by === 'ron') {
    return (
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '6px 8px', background: th.bg, borderRadius: 4 }}>
        <span style={{ fontSize: 11, color: th.ink2 }}>放铳者支付</span>
        <span style={{ fontSize: 16, fontWeight: 600, color: th.accent, fontFamily: '"PingFang SC","Hiragino Mincho ProN","Songti SC",ui-serif,serif' }}>
          {(result.pay.ron || 0).toLocaleString()}
          <span style={{ fontSize: 9, marginLeft: 2 }}>点</span>
        </span>
      </div>
    );
  }
  // 自摸
  if (isDealer) {
    return (
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '6px 8px', background: th.bg, borderRadius: 4 }}>
        <span style={{ fontSize: 11, color: th.ink2 }}>每子家付</span>
        <span style={{ fontSize: 16, fontWeight: 600, color: th.accent, fontFamily: '"PingFang SC","Hiragino Mincho ProN","Songti SC",ui-serif,serif' }}>
          {(result.pay.eachChild || 0).toLocaleString()} <span style={{ fontSize: 10 }}>× 3</span>
        </span>
      </div>
    );
  }
  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6 }}>
      <div style={{ padding: '6px 8px', background: th.bg, borderRadius: 4 }}>
        <div style={{ fontSize: 9, color: th.ink2 }}>亲家付</div>
        <div style={{ fontSize: 14, fontWeight: 600, color: th.accent, fontFamily: '"PingFang SC","Hiragino Mincho ProN","Songti SC",ui-serif,serif' }}>{(result.pay.fromDealer || 0).toLocaleString()}</div>
      </div>
      <div style={{ padding: '6px 8px', background: th.bg, borderRadius: 4 }}>
        <div style={{ fontSize: 9, color: th.ink2 }}>每子家付</div>
        <div style={{ fontSize: 14, fontWeight: 600, color: th.accent, fontFamily: '"PingFang SC","Hiragino Mincho ProN","Songti SC",ui-serif,serif' }}>{(result.pay.fromChild || 0).toLocaleString()} <span style={{ fontSize: 9 }}>× 2</span></div>
      </div>
    </div>
  );
}

// ====================== Keyboard ======================
function Keyboard({ th, s, onPick, focus }) {
  const rows = [
    { key: 'm', label: '萬', tiles: ['1m','2m','3m','4m','5m','6m','7m','8m','9m','0m'] },
    { key: 'p', label: '筒', tiles: ['1p','2p','3p','4p','5p','6p','7p','8p','9p','0p'] },
    { key: 's', label: '索', tiles: ['1s','2s','3s','4s','5s','6s','7s','8s','9s','0s'] },
    { key: 'z', label: '字', tiles: ['1z','2z','3z','4z','5z','6z','7z'] },
  ];
  const focusLabel = focus === 'hand' ? '手牌' : focus === 'dora' ? '宝牌指示' : focus === 'ura' ? '里宝指示' : focus.startsWith('meld:') ? '副露' : '';
  return (
    <div style={s.keyboard}>
      <div style={{ fontSize: 9, color: th.ink2, padding: '0 6px 6px', display: 'flex', justifyContent: 'space-between' }}>
        <span style={{ letterSpacing: '0.2em' }}>选 牌 <span style={{ color: th.accent, marginLeft: 4 }}>→ {focusLabel}</span></span>
        <span style={{ letterSpacing: '0.15em' }}>0 = 赤宝 5</span>
      </div>
      {rows.map(r => (
        <div key={r.key} style={{ display: 'flex', gap: 2, padding: '0 4px 3px', justifyContent: r.key === 'z' ? 'flex-start' : 'space-between' }}>
          {r.tiles.map(t => (
            <div key={t} onClick={() => onPick(t)}
              style={{ padding: 2, cursor: 'pointer', borderRadius: 3, transition: 'background 100ms' }}
              onTouchStart={(e) => e.currentTarget.style.background = th.accent + '22'}
              onTouchEnd={(e) => e.currentTarget.style.background = 'transparent'}
              onMouseDown={(e) => e.currentTarget.style.background = th.accent + '22'}
              onMouseUp={(e) => e.currentTarget.style.background = 'transparent'}
              onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}>
              <_Tile2 tile={t} size={r.key === 'z' ? 36 : 32} />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}

// ====================== HistoryDrawer ======================
function HistoryDrawer({ th, history, onClose, onClear }) {
  return (
    <Drawer th={th} title="历史记录" onClose={onClose}>
      {history.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '40px 0', color: th.ink2, fontSize: 12 }}>暂无记录</div>
      ) : (
        <>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {history.map((h, i) => (
              <div key={i} style={{ padding: '10px 12px', background: th.surface, border: `1px solid ${th.line}`, borderRadius: 4 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
                  <span style={{ fontSize: 14, fontWeight: 600, color: th.accent, fontFamily: '"PingFang SC","Hiragino Mincho ProN","Songti SC",ui-serif,serif' }}>
                    {h.total.toLocaleString()} 点 {h.name && `· ${h.name}`}
                  </span>
                  <span style={{ fontSize: 10, color: th.ink2 }}>{new Date(h.ts).toLocaleString('zh-CN', {month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit'})}</span>
                </div>
                <div style={{ fontSize: 10, color: th.ink2, marginBottom: 4 }}>{h.fu} 符 {h.han} 番 · {h.by === 'tsumo' ? '自摸' : '荣和'}</div>
                <div style={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                  {h.hand.map((t, j) => <_Tile2 key={j} tile={t} size={20} />)}
                </div>
              </div>
            ))}
          </div>
          <button onClick={onClear} style={{ marginTop: 12, width: '100%', padding: '8px', fontSize: 11, color: th.ink2, background: 'transparent', border: `1px solid ${th.line}`, borderRadius: 4, cursor: 'pointer', letterSpacing: '0.2em' }}>清 空 历 史</button>
        </>
      )}
    </Drawer>
  );
}

// ====================== SettingsDrawer ======================
function SettingsDrawer({ th, onClose, tweaks, setTweak }) {
  const themesList = [['wafu', '和风'], ['yajou', '雀庄夜场'], ['mono', '极简']];
  return (
    <Drawer th={th} title="设置" onClose={onClose}>
      <div style={{ marginBottom: 16 }}>
        <div style={{ fontSize: 10, color: th.ink2, letterSpacing: '0.2em', marginBottom: 6 }}>主题</div>
        <div style={{ display: 'flex', gap: 6 }}>
          {themesList.map(([k, v]) => (
            <button key={k} onClick={() => setTweak('theme', k)}
              style={{
                flex: 1, padding: '8px 0', fontSize: 12,
                border: `1px solid ${tweaks.theme === k ? th.accent : th.line}`,
                background: tweaks.theme === k ? th.accent : th.panel,
                color: tweaks.theme === k ? '#fff' : th.ink,
                borderRadius: 4, cursor: 'pointer', fontFamily: '"PingFang SC","Hiragino Mincho ProN","Songti SC",ui-serif,serif'
              }}>{v}</button>
          ))}
        </div>
      </div>

      <div style={{ marginBottom: 16 }}>
        <div style={{ fontSize: 10, color: th.ink2, letterSpacing: '0.2em', marginBottom: 6 }}>显示符内详</div>
        <button onClick={() => setTweak('showFuDetail', !tweaks.showFuDetail)}
          style={{
            padding: '6px 14px', fontSize: 12,
            border: `1px solid ${tweaks.showFuDetail ? th.accent : th.line}`,
            background: tweaks.showFuDetail ? th.accent : th.panel,
            color: tweaks.showFuDetail ? '#fff' : th.ink,
            borderRadius: 4, cursor: 'pointer', fontFamily: '"PingFang SC","Hiragino Mincho ProN","Songti SC",ui-serif,serif'
          }}>{tweaks.showFuDetail ? '已开' : '已关'}</button>
      </div>

    </Drawer>
  );
}

function Drawer({ th, title, onClose, children }) {
  return (
    <div onClick={onClose} style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,.4)',
      zIndex: 100, display: 'flex', alignItems: 'flex-end',
      animation: 'fadeIn 200ms'
    }}>
      <div onClick={(e) => e.stopPropagation()} style={{
        width: '100%', maxWidth: 420, margin: '0 auto',
        background: th.bg, borderTopLeftRadius: 12, borderTopRightRadius: 12,
        maxHeight: '80vh', overflowY: 'auto',
        animation: 'slideUp 240ms cubic-bezier(.2,.8,.2,1)'
      }}>
        <div style={{ position: 'sticky', top: 0, padding: '14px 16px', background: th.panel, borderBottom: `1px solid ${th.line}`, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontSize: 14, fontWeight: 600, color: th.ink, letterSpacing: '0.2em', fontFamily: '"PingFang SC","Hiragino Mincho ProN","Songti SC",ui-serif,serif' }}>{title}</span>
          <button onClick={onClose} style={{ width: 28, height: 28, border: `1px solid ${th.line}`, background: 'transparent', color: th.ink2, borderRadius: 4, cursor: 'pointer' }}>×</button>
        </div>
        <div style={{ padding: '14px 16px 24px' }}>{children}</div>
      </div>
    </div>
  );
}

Object.assign(window, { ResultSection, Keyboard, HistoryDrawer, SettingsDrawer });
